export default "__VITE_ASSET__DpC4HD0U__"